import { defineMessages } from 'react-intl';

export const i18n: {
	pullRequestStatusLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	pullRequestStatusLabel: {
		id: 'search-page.filters.names.pull-request-status',
		defaultMessage: 'PR status',
		description: 'Label for filtering by pull request status',
	},
});
